import type { SizeOption } from '../domain/models/CustomizationOptions';

export type { SizeOption };

function normalizeCustomizationOptions(customizationOptions: unknown): Record<string, unknown> | null {
  if (!customizationOptions) return null;
  if (typeof customizationOptions === 'string') {
    try {
      const parsed = JSON.parse(customizationOptions) as unknown;
      return parsed && typeof parsed === 'object'
        ? (parsed as Record<string, unknown>)
        : null;
    } catch {
      return null;
    }
  }
  if (typeof customizationOptions === 'object') {
    return customizationOptions as Record<string, unknown>;
  }
  return null;
}

export function parseSizeList(customizationOptions: unknown): SizeOption[] {
  const opts = normalizeCustomizationOptions(customizationOptions);
  if (!opts) return [];

  const sizes = opts['size'];
  if (!Array.isArray(sizes)) return [];

  return sizes
    .map((item) => {
      if (item && typeof item === 'object') {
        const row = item as Record<string, unknown>;
        return {
          key: String(row.key ?? ''),
          value: String(row.value ?? row.displaySize ?? ''),
        };
      }
      return { key: '', value: '' };
    })
    .filter((item) => item.key !== '');
}

export function normalizeSizeKey(key: string | number | null | undefined): string {
  if (key == null || key === '') return '';
  const keyStr = String(key).trim();
  if (/^0+\d+$/.test(keyStr)) {
    return String(parseInt(keyStr, 10));
  }
  return keyStr;
}

export function findSizeOption(sizes: SizeOption[], key: string | number | null | undefined): SizeOption | null {
  if (key == null || key === '') return null;
  const normalizedKey = normalizeSizeKey(key);
  return sizes.find((size) => normalizeSizeKey(size.key) === normalizedKey) ?? null;
}

export function getSizeLabel(category: string): string {
  const lengthCategories = ['Chains', 'Mangalsutra Chains', 'Necklaces', 'Anklets'];
  return lengthCategories.includes(category) ? 'Length (in inches)' : 'Size';
}
